module.exports = __webpack_public_path__ + "resources/img/img_ai_fashion.3d5b9623e4281364ce4b8a37e697700a.png";